const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const getLeadFilesApi = async (leadId, params = {}) => {
  const token = localStorage.getItem('token');
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    searchParams.set(key, String(value));
  });

  const query = searchParams.toString();
  const response = await fetch(
    `${API_BASE_URL}/admin/lead/leads/${leadId}/files${query ? `?${query}` : ''}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    const error = new Error('Failed to fetch lead files');
    error.status = response.status;
    throw error;
  }

  return response.json();
};

export default getLeadFilesApi;
